import { getAccessToken } from '@/hooks/useAuth';
import { gerarEmailConfirmacaoTransacao, TipoTransacao, DestinatarioResgate } from '@/components/emails/EmailConfirmacaoTransacao';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://www.getpoints.com.br';

interface EnviarEmailPayload {
  destinatario: string;
  assunto: string;
  html: string;
}

interface EnviarEmailResponse {
  success: boolean;
  data?: { messageId?: string };
  message?: string;
}

async function chamarApiEmail(payload: EnviarEmailPayload): Promise<void> {
  const token = getAccessToken();

  if (!token) {
    console.warn('[EmailService] Token JWT não encontrado — pulando envio de email.');
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/v1/emails/enviar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => 'N/A');
      console.error(`[EmailService] API retornou ${response.status}: ${errorText}`);
      return;
    }

    const json: EnviarEmailResponse = await response.json().catch(() => null);
    if (json?.success) {
      console.log(`[EmailService] Email enviado com sucesso para ${payload.destinatario}`);
    } else {
      console.warn('[EmailService] API retornou sucesso=false:', json?.message || 'sem mensagem');
    }
  } catch (err) {
    console.error('[EmailService] Erro ao chamar API de email:', err);
  }
}

export interface DadosEnvioTransacao {
  nomeParticipante: string;
  emailParticipante: string;
  tipo: TipoTransacao;
  valor: number;
  moeda?: string;
  data: string;
  hora: string;
  idTransacao: string;
  descricao?: string;
  saldoAtual?: number;
  minutosExpiracao?: number;
  destinatario?: DestinatarioResgate;
}

/**
 * Envia email de confirmação de transação via API do backend.
 * Fire-and-forget: não bloqueia o fluxo do usuário.
 */
export function enviarEmailConfirmacaoTransacao(dados: DadosEnvioTransacao): void {
  const html = gerarEmailConfirmacaoTransacao({
    nome: dados.nomeParticipante,
    tipo: dados.tipo,
    valor: dados.valor,
    moeda: dados.moeda,
    data: dados.data,
    hora: dados.hora,
    idTransacao: dados.idTransacao,
    descricao: dados.descricao,
    saldoAtual: dados.saldoAtual,
    minutosExpiracao: dados.minutosExpiracao,
    destinatario: dados.destinatario,
  });

  const assunto = 'Transação Confirmada - GetPoints';

  chamarApiEmail({
    destinatario: dados.emailParticipante,
    assunto,
    html,
  });
}